import 'isomorphic-fetch';
import { config } from './config'

const options = (method, data) => {
    let opt = {
        method,
        headers: {
            'Content-Type': 'application/json',
            'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
        }
    };
    if (data) {
        opt.body = JSON.stringify(data);
    }
    return opt;
};

export const api = {

    auth: {
        async login(data) {
            const response = await fetch(config.URL_API + '/login', options('POST', data));
            const responseData = await response.json();
            return responseData;
        },
        async firstLogin(data) {
            const response = await fetch(config.URL_API + '/firstlogin', options('POST', data));
            const responseData = await response.json();
            return responseData;
        },
        async getAuthenticatedUser() {
            const response = await fetch(config.URL_API + '/authenticated', options('GET'));
            const data = await response.json();
            return data;
        },
        async changePass(data) {
            const response = await fetch(config.URL_API + '/changepass', options('POST', data));
            const responseData = await response.json();
            return responseData;
        },
    },
    user:{
      async upload() {
          return config.URL_API + '/usuarios/upload'
      },

      async uQpload(form) {
        const response = await fetch(config.URL_API + '/usuarios/upload', {
            method: 'POST',
            headers: {
                'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: form
        });
        const data = await response.json();
        return data;

      },
      async changePassword(id, data) {
          const response = await fetch(config.URL_API + '/password/' + id, {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
                  'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
              },
              body: JSON.stringify(data)
          });
          const responseData = await response.json();
          return responseData;
      },
      async update(data) {
          const response = await fetch(config.URL_API + '/usuarios', {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
                  'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
              },
              body: JSON.stringify(data)
          });
          const responseData = await response.json();
          return responseData;
      },
      async updateprofile(data) {
          const response = await fetch(config.URL_API + '/usuarios/profile', {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
                  'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
              },
              body: JSON.stringify(data)
          });
          const responseData = await response.json();
          return responseData;
      },
    },
    usuarios: {
        async create(data) {
            const response = await fetch(config.URL_API + '/usuarios', options('POST', data));
            const responseData = await response.json();
            return responseData;
        },
        async getAll(query = '') {
            const response = await fetch(config.URL_API + `/usuarios?${query}`, options('GET'));
            const data = await response.json();
            return data;
        },
        async getAllbyRol(rol) {
            const response = await fetch(config.URL_API + `/usuarios/rol/${rol}`, options('GET'));
            const data = await response.json();
            return data;
        },
        async get(id) {
            const response = await fetch(config.URL_API + `/usuarios/${id}`, options('GET'));
            const data = await response.json();
            return data;
        },
        async update(data) {
            const response = await fetch(config.URL_API + '/usuarios', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: JSON.stringify(data)
            });
            const responseData = await response.json();
            return responseData;
        },
        async baja(id) {
            const response = await fetch(config.URL_API + '/usuarios/baja/' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
            });
            const responseData = await response.json();
            return responseData;
        },
        async alta(id) {
            const response = await fetch(config.URL_API + '/usuarios/alta/' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
            });
            const responseData = await response.json();
            return responseData;
        },
        async blanquearClave(id, values) {
            const response = await fetch(config.URL_API + '/blanqueo/'+id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: JSON.stringify(values)
            });
            const responseData = await response.json();
            return responseData;
        },
        async cambiarClave(id, values) {
            const response = await fetch(config.URL_API + '/password/' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: JSON.stringify(values)
            });
            const responseData = await response.json();
            return responseData;
        }
    },
    roles: {
        async create(data) {
            const response = await fetch(config.URL_API + '/roles', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
                },
                body: JSON.stringify(data)
            });
            const responseData = await response.json();
            return responseData;
        },
        async getAll(query = '') {
            const response = await fetch(config.URL_API + '/roles?' + query, options('GET'));
            const data = await response.json();
            return data;
        },
        async get(id) {
            const response = await fetch(config.URL_API + `/roles/${id}`, options('GET'));
            const data = await response.json();
            return data;
        },
        async update(data) {
            const response = await fetch(config.URL_API + '/roles', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
                body: JSON.stringify(data)
            });
            const responseData = await response.json();
            return responseData;
        },
        async delete(id) {
            const response = await fetch(config.URL_API + '/roles/' + id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`,
                },
            });
            const responseData = await response.json();
            return responseData;
        },
    },
    vendedores:{
      async getAll(query = '') {
				const response = await fetch(config.URL_API + '/vendedores?'+ query, {
					method: 'GET',
					headers: {'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`},
				});
				const data = await response.json();
				return data;
			},
    },
    clientes:{
			async getAll(query = '') {
				const response = await fetch(config.URL_API + '/clientes?'+ query, {
					method: 'GET',
					headers: {'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`},
				});
				const data = await response.json();
				return data;
			},
			async get(id) {
				const response = await fetch(config.URL_API + '/clientes/'+id, {
					method: 'GET',
					headers: {'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`},
				});
				const data = await response.json();
				return data;
			},
		},
};
